import { z } from 'zod';
import {
  projectSchema,
  type CreateProjectRequest,
  type Project,
  type UpdateProjectRequest,
} from '@mrrmlab/shared-types';
import type { HttpClient } from './http';

const projectListSchema = z.array(projectSchema);

export class ProjectsResource {
  constructor(private readonly http: HttpClient) {}

  list(signal?: AbortSignal): Promise<Project[]> {
    return this.http.request({
      method: 'GET',
      path: '/projects',
      responseSchema: projectListSchema,
      signal,
    });
  }

  create(body: CreateProjectRequest, signal?: AbortSignal): Promise<Project> {
    return this.http.request({
      method: 'POST',
      path: '/projects',
      body,
      responseSchema: projectSchema,
      signal,
    });
  }

  update(id: string, body: UpdateProjectRequest, signal?: AbortSignal): Promise<Project> {
    return this.http.request({
      method: 'PATCH',
      path: `/projects/${id}`,
      body,
      responseSchema: projectSchema,
      signal,
    });
  }

  delete(id: string, signal?: AbortSignal): Promise<void> {
    return this.http.request({
      method: 'DELETE',
      path: `/projects/${id}`,
      expectEmpty: true,
      signal,
    });
  }
}
